var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___TmQ3Rl",
  "yF": "AutocompleteEmoji.module__divider___TmQ3Rl",
  "mI": "AutocompleteEmoji.module__emojiIcon___TmQ3Rl",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___TmQ3Rl",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___TmQ3Rl",
  "lA": "AutocompleteEmoji.module__stickerIcon___TmQ3Rl",
  "Cu": "AutocompleteEmoji.module__memeIcon___TmQ3Rl",
  "_Q": "AutocompleteEmoji.module__memeVideo___TmQ3Rl",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___TmQ3Rl",
  "iw": "AutocompleteEmoji.module__audioIcon___TmQ3Rl",
};

module.exports = exports;
